<template>
  <div :class="['max-w-7xl mx-auto md:flex md:items-center md:justify-between', appendClasses]">
    <div class="flex-1 min-w-0">
      <h3 class="">
        {{ title }}
      </h3>
    </div>
    <div class="mt-4 flex md:mt-0 md:ml-4">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    },
    class: {
      type: String,
      default() {
        return ''
      }
    }
  },

  computed: {
    appendClasses() {
      return this.class
    }
  }
}
</script>
